var map = {
	"./add-circle.svg": "6326",
	"./arrow-left.svg": "edd4",
	"./arrow-right.svg": "5d5c",
	"./bars.svg": "4025",
	"./building.svg": "8d62",
	"./cardiology.svg": "cb5d",
	"./check.svg": "872f",
	"./dashboard.svg": "d058",
	"./description.svg": "9a9d",
	"./dot.svg": "a2ab",
	"./event-note.svg": "3226",
	"./flag.svg": "8d6e",
	"./help.svg": "f9da",
	"./location.svg": "1718",
	"./map.svg": "fb52",
	"./national.svg": "7b63",
	"./notification.svg": "6f79",
	"./package.svg": "c645",
	"./settings.svg": "e133",
	"./syringe.svg": "4078",
	"./users.svg": "8a65",
	"./v-logo.svg": "d3a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d55";